import React from 'react';

const fieldStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
};

const rowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
};

const textStyle = {
    maxWidth: 720,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

const getUrlName = url => {
    if (!url) {
        return '';
    }

    return url.split('/').pop();
};

const getItemText = item => {
    if (item.text) {
        return item.text;
    }

    if (item.url) {
        return `Icon: ${getUrlName(item.url)}`;
    }

    return `Item #${item.position}`;
};

const CashbackItemsField = ({record = {}, limit}) => {
    const items = (record.items || [])
        .filter(item => item.text || item.url)
        .sort((a, b) => (a.position || 0) - (b.position || 0));

    if (!items.length) {
        return <span>-</span>;
    }

    const visibleItems = limit ? items.slice(0, limit) : items;

    return (
        <div style={fieldStyle}>
            {visibleItems.map(item => (
                <div key={item.id} style={rowStyle}>
                    <span style={textStyle}>{getItemText(item)}</span>
                </div>
            ))}
            {limit && items.length > limit && (
                <span>{items.length - limit} more</span>
            )}
        </div>
    );
};

CashbackItemsField.defaultProps = {
    label: 'Items',
};

export default CashbackItemsField;
